import {DxGridModalsProvider} from "../../dx-grid/domain/providers/dx-grid-modals-provider";
import {ComponentFactory, ComponentFactoryResolver, Injectable} from "@angular/core";
import {DxModalService} from "../../dx-modals/services/dx-modal.service";
import {Observable} from "rxjs";
import {DxModalResultType} from "../../dx-modals/domain/dx-modal-result-type";
import {fromPromise} from "rxjs/internal-compatibility";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {PitActivityModalCardComponent} from "../../pit-activities/ui/components/activity-modal-card/pit-activity-modal-card.component";


@Injectable()
export class PitGridModalsService implements DxGridModalsProvider {

  constructor(private _modalService: DxModalService,
              protected resolver: ComponentFactoryResolver) {}

  public showError(message: string): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._modalService.showError(message).subscribe(result => {
        if(DxModalResultType.OK === result.type) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    });
    return fromPromise<boolean>(promise);
  }


  public showConfirm(message: string): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._modalService.showConfirm(message).subscribe(result => {
        if(DxModalResultType.OK === result.type) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    });
    return fromPromise<boolean>(promise);
  }

  public showInfo(message: string): Observable<boolean> {
    const promise = new Promise<boolean>((resolve) => {
      this._modalService.showInfo(message).subscribe(result => {
        if(DxModalResultType.OK === result.type) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    });
    return fromPromise<boolean>(promise);
  }

  public showEditForm(row: DxGridRow): Observable<DxGridRow> {
    return undefined;
  }

}
